const getApiURL = () => {
    return "https://app.rcta.me";
};

let apiURL = process.env.REACT_APP_APP_URL ?? getApiURL();

export const API_FRONT_URL = apiURL;
